module.exports = __webpack_public_path__ + "img/case2.27386201.png";